<template>
  <v-container>
    <v-form ref="form" v-model="formValid" @submit.prevent="changePassword">
      <v-text-field label="Aktuelles Passwort" type="password" v-model="currentPassword" :rules="[ruleRequired]" />
      <v-text-field label="Neues Passwort" type="password" v-model="newPassword" :rules="[rulePassword]" />
      <v-text-field label="Passwort wiederholen" type="password" v-model="newPasswordRepeat" :rules="[rulePasswordRepeat]" />
      <v-btn
        type="submit"
        block
        color="primary"
        :loading="loading"
        :disabled="loading"
      >Passwort ändern</v-btn>
    </v-form>
  </v-container>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import {changePassword as changePasswordApi} from '@/api/module/misc';
import {useRouter} from 'vue-router';
import {doAlert} from '@/util';
import {VNodeRef} from 'vue';

const router = useRouter();

const formValid = ref(false);
const loading = ref(false);
const currentPassword = ref('');
const newPassword = ref('');
const newPasswordRepeat = ref('');

const form = ref<HTMLFormElement & VNodeRef | undefined>();

watch(() => [newPassword.value, newPasswordRepeat.value], () => form.value?.validate());


async function changePassword() {
  try {
    loading.value = true;
    if (!form.value?.validate()) return;
    await changePasswordApi(currentPassword.value, newPassword.value);
    await doAlert('Passwort erfolgreich geändert');
    router.push({name: 'dashboard'}).catch(console.error);
  } catch (err) {
    let message = (err as Error).message;
    if (message === 'current password wrong') message = 'Das aktuelle Passwort ist nicht korrekt.';
    await doAlert(message);
  } finally {
    loading.value = false;
  }
}

function rulePasswordRepeat(value: string) {
  return value === newPassword.value || 'Passwörter stimmen nicht überein';
}

function rulePassword(value: string | null | undefined) {
  if (!value) return 'erforderlich';
  if (value.length < 6) return 'mindestens sechs Zeichen';
  if (value.match(/^\d+$/)) return 'nicht nur Zahlen';
  if (value.match(/^[a-z]+$/)) return 'nicht nur Kleinbuchstaben';
  if (value.match(/^[A-Z]+$/)) return 'nicht nur Großbuchstaben';
  if (value.match(/^[A-Z][a-z]+$/)) return 'nicht nur ein Wort';

  return true;
}

function ruleRequired(value: string | null | undefined) {
  return Boolean(value) || 'erforderlich';
}

defineExpose({
  formValid,
  loading,
  currentPassword,
  newPassword,
  changePassword,
  rulePasswordRepeat,
  rulePassword,
  ruleRequired,
});
</script>
